// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","headerContainer":"_3h47L","banner":"GEbvk","header":"_3Co-F","headingTitle":"jUQfL","headingSubtitle":"_1SY18","downArrow":"_3X1Y_"};